export const appTableClsPrefix = 'app-table';
export const bodyRowClsPrefix = `${appTableClsPrefix}__body-row`;
export const cellClsPrefix = `${appTableClsPrefix}__cell`;
export const headerCellClsPrefix = `${appTableClsPrefix}__header-cell`;
export const bodyCellClsPrefix = `${appTableClsPrefix}__body-cell`;
